import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { PaymentGroupContent } from './PaymentGroupContent';
import { usePaymentState } from '../../../../context/CheckoutPaymentContext';
import { useAemConfig } from '@as-react/common-components';
import Klarna from '../../../../util/KlarnaUtil';
import { Spinner, StackBlock, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useSavePaymentOption } from '../../../../hooks/useSavePaymentOption';
const SCRIPT_KEY = 'klarna-payments-sdk-js';
export const PaymentGroupKlarna = ({ disabled, selected, group }) => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const [isKlarnaLoaded, setIsKlarnaLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    const { klarnaConfig } = useAemConfig();
    const { savePaymentOptions, errorMessage, isLoading } = useSavePaymentOption();
    const [{ info, optionError, klarnaToken }] = usePaymentState();
    const optionSelectError = optionError[group.name];
    const klarnaError = hasError ? t('buy.payment.form.error') : undefined;
    const initKlarna = (token) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield Klarna.init({
                token,
                url: klarnaConfig.paymentsScriptUrl,
                key: SCRIPT_KEY,
            });
            Klarna.load('#klarna_container', [group.paymentOptions[0].paymentMethodCode], info.orderReference, () => {
                setIsKlarnaLoaded(true);
            });
        }
        catch (_a) {
            setIsKlarnaLoaded(false);
            setHasError(true);
        }
    });
    useEffect(() => {
        if (!klarnaToken) {
            return;
        }
        initKlarna(klarnaToken);
    }, [klarnaToken]);
    return (_jsx(PaymentGroupContent, { onSubmit: () => savePaymentOptions({ group }), disabled: disabled, isSubmitting: isLoading, error: errorMessage || optionSelectError || klarnaError, selected: selected, group: group, children: selected && (_jsxs(_Fragment, { children: [!klarnaToken && !isKlarnaLoaded && !hasError && !optionSelectError && (_jsxs(StackBlock, { gap: "4", itemsAlign: "center", children: [_jsx(Spinner, { size: "small", fitContainer: true }), _jsx(TextAlpha, { children: t(`${I18N_NAMESPACES.buy}:buy.payment.klarna.loading.message`) })] })), klarnaToken && _jsx("div", { id: "klarna_container", style: { display: isKlarnaLoaded ? 'block' : 'none' } })] })) }));
};
